
export const MyEnum = {
    Dashboard: 10,
    MyCert: 20,

  }
  